import "slick-carousel";
import "imagesloaded";

function initSlider($selector, options) {
  if ($selector.length && !$selector.hasClass("slick-initialized")) {
    $selector.slick(options);
  }
}

jQuery(document).ready(function ($) {
  $(".blocks-gallery-item").addClass("mySlides");
  $(".blocks-gallery-grid").addClass("slideshow-container");
  $(".wp-block-gallery").append(
    "<img class='slider-loading' src='/content/themes/3a2ilati/src/assets/images/svg/ico-spinner.svg'>"
  );
  const $sliderStages = $(".slideshow-container");

  const sliderStages = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    dots: false,
    arrows: true,
    autoplay: false,
    rtl: true,
  };

  $sliderStages.on(
    "init reInit afterChange",
    function (event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;

      $(this)
        .siblings(".slideshow-counter")
        .children(".slideshow-count")
        .text(i);
      $(this)
        .siblings(".slideshow-counter")
        .children(".slideshow-count-all")
        .text(slick.slideCount);
    }
  );

  // initSlider($sliderStages, sliderStages);

  const unicodeRightArrowText = "1433";
  let unicodeRightArrowChar = JSON.parse(`["\\u${unicodeRightArrowText}"]`)[0];

  const unicodeLeftArrowText = "1438";
  let unicodeLeftArrowChar = JSON.parse(`["\\u${unicodeLeftArrowText}"]`)[0];

  $(".slideshow-container .slick-prev").text(unicodeRightArrowChar);

  $(".slideshow-container .slick-next").text(unicodeLeftArrowChar);

  for (let i = 0; i < $(".slideshow-container").length; i++) {
    $(".slideshow-container")[i].classList.add(`slideshow-${i}`);
    let title = $(`.slideshow-${i}`).parent().prev("h2").prop("outerHTML");
    if ($(`.slideshow-${i}`).parent().prev("h2")) {
      $(`.slideshow-${i}`).parent().prev("h2").remove();
    }

    $(`.slideshow-${i}`).parent().append(title);
    $(`.slideshow-${i}`)
      .parent()
      .append(
        `<div class="slideshow-counter"><span  class="slideshow-count"></span>/<span class="slideshow-count-all"></span></div>`
      );

    $(`.slideshow-${i} .mySlides`)
      .imagesLoaded()
      .done(function (instance) {
        setTimeout(() => {
          initSlider($(`.slideshow-${i}`), sliderStages);

          if ($(`.slideshow-${i} .slick-prev`).length > 0) {
            $(`.slideshow-${i} .slick-prev`)[0].innerHTML =
              '<img src="/content/themes/3a2ilati/src/assets/images/svg/ionic-ios-arrow-down.svg">';
          }

          if ($(`.slideshow-${i} .slick-next`).length > 0) {
            $(`.slideshow-${i} .slick-next`)[0].innerHTML =
              '<img src="/content/themes/3a2ilati/src/assets/images/svg/ionic-ios-arrow-down.svg">';
          }

          $(`.slideshow-${i}`).append('<a class="slick-max"></a>');

          $(`.slideshow-${i}`)
            .siblings(".slider-loading")
            .css("display", "none");
          $(`.slideshow-${i}`).css("display", "block");
          $(`.slideshow-${i}`)
            .siblings(".slideshow-counter")
            .css("display", "block");
        }, 1500);
      })
      .fail(function () {
        return;
      });
  }

  $(".blocks-gallery-item__caption").each(function () {
    if (!$(this).text() || $(this).text() == "") {
      $(this).css("display", "none");
    }
  });

  $(document).on("click", ".slick-max", function () {
    $(this).parent().parent().toggleClass("full-screen");
    $("body").toggleClass("no-scroll");
    $("html").toggleClass("no-scroll");
    $(".slideshow-container").slick("resize");
    $(".slideshow-container").slick("setPosition");

    let title = $(".mySlides > p");
    title.each(function () {
      $(this).css("top", $(this).siblings("h3").outerHeight() + 20);
    });
  });
});
